import { defineStore } from "pinia";

import modelClass from "@models/course";
import * as getters from "@modelStores/helpers/getters-helper";

export const useCourseStore = defineStore("course-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
